import ApplicationInit from './app/init.js'
import { CssAnimation } from './utils/CssAnimation.js';

global.RS = global.RS || {};

global.RS = Object.assign(global.RS, {
	Init: ApplicationInit,
	CssAnimation
});